import { useState, useEffect } from "react";
import {
  Box,
  HStack,
  Text,
  Button,
  Input,
  BoxProps,
  Tag,
  TagLabel,
  TagCloseButton,
  Flex,
  InputProps,
} from "@chakra-ui/react";
import toast from "react-hot-toast";

interface Props {
  onChange: (list: string[]) => void;
  initValue?: string[];
  buttonText?: string;
  inputProps?: InputProps;
  mainContainerProps?: BoxProps;
  helperText?: string
}

export function InputWithList({
  onChange,
  initValue,
  buttonText = "Add",
  inputProps = {},
  mainContainerProps = {},
  helperText
}: Props) {
  const [text, setText] = useState<string>("");
  const [words, setWords] = useState<string[]>([]);

  useEffect(() => {
    setWords(initValue || []);
  }, []);

  const handleAdd = () => {
    if (!text.trim()) {
      toast.error("Please enter some text");
      return;
    }

    if (!words.includes(text.trim())) {
      const updatedList = [...words, text];
      setWords(updatedList);
      onChange(updatedList);
    }

    setText("");
  };

  const handleDelete = (word: string) => {
    const filteredWords = [...words].filter((w) => w !== word);
    setWords(filteredWords);
    onChange(filteredWords);
  };

  return (
    <Box ml="3" w="min-content" {...mainContainerProps}>
      <Box>
        <HStack>
          <Input
            size="sm"
            borderRadius="lg"
            value={text}
            onChange={(e) => setText(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                handleAdd();
              }
            }}
            width="170px"
            {...inputProps}
          />
          <Button variant={"primary"} size="sm" px="6" onClick={handleAdd}>
            {buttonText}
          </Button>
        </HStack>
        {helperText ? (<Text color="gray.500" fontSize="xs" ml="1" mt="1">{helperText}</Text>) : null}
      </Box>
      {words?.length > 0 && (
        <Flex mt="4" flexWrap="wrap">
          {words.map((word) => (
            <Tag
              size="sm"
              key={word}
              borderRadius="full"
              variant="solid"
              colorScheme="gray"
              pl="4"
              m="1"
            >
              <TagLabel>{word}</TagLabel>
              <TagCloseButton onClick={() => handleDelete(word)} />
            </Tag>
          ))}
        </Flex>
      )}
    </Box>
  );
}
